import { Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Tasks from "./pages/Tasks";
import Products from "./pages/Products";
import Profiles from "./pages/Profiles";
import Proxies from "./pages/Proxies";
import Orders from "./pages/Orders";
import Search from "./pages/Search";
import Queue from "./pages/Queue";
import Logs from "./pages/Logs";
import Settings from "./pages/Settings";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="products" element={<Products />} />
          <Route path="search" element={<Search />} />
          <Route path="profiles" element={<Profiles />} />
          <Route path="proxies" element={<Proxies />} />
          <Route path="queue" element={<Queue />} />
          <Route path="orders" element={<Orders />} />
          <Route path="logs" element={<Logs />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
      <Analytics />
    </>
  );
}

